import { createTheme } from '@mui/material/styles';
import * as colors from '@mui/material/colors';

// Ajust MUI Theme here:
const adjustedMuiTheme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#343A40',
    },
    success: {
      main: '#B0D4A3',
    },
  },
  typography: {
    fontFamily: ['San Francisco', 'sans-serif'].join(','),
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '13px',
          '&:hover': {
            color: 'black',
            backgroundColor: '#F1BB69',
          },
        },
      },
    },
  },
});

// Ajust/add User Theme here:
const userTheme = {
  color: {
    red: colors.red[300],
    blue: colors.blue[600],
    white: 'white',
    gray: 'darkgray',
    black: 'black',
    orange: '#F1BB69',
    datagridHeader: '#FEECD9',
  },
  fontSize: {
    default: '16px',
    small: '12px',
  },
  header: {
    height: '56px',
    backgroundColor: '#24292E',
  },
  sidebar: {
    width: '268px',
    backgroundColor: '#24292E',
  },
};

export const theme = { ...adjustedMuiTheme, ...userTheme };
